import React from 'react'

const PageNotFound = () => {
    return (
        <div id="wrapper" className='text-center m-5'>
            {/* <img src="https://i.imgur.com/qIufhof.png" /> */}
            <div id="info m-5">
                <h3 className='text-info'>This page could not be found</h3>
            </div>
        </div >
    )
}

export default PageNotFound